import { createStyles } from "@mantine/core";

export const useTableStyles = createStyles((theme) => {
    return {
        tableWrapper: {
            maxWidth: '100%',
            overflowY: 'hidden',
            overflowX: 'auto',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        headerRow: {
            background: theme.fn.gradient({
                from: theme.other.gradientFrom,
                to: theme.other.gradientTo,
                deg: 270
            }),
        },
        paginationWrapper: {
            justifyContent: 'space-between',
            display: 'flex',
            alignItems: 'center',
            marginTop: theme.spacing.xs
        },
        pagination: {
            display: 'flex',
            gap: theme.spacing.xs - 5,
        },
        paginationIcon: {
            fontSize: 25
        },
        quickJumper: {
            width: 50
        },
        pageSize: {
            width: 80
        },
        header: {
            marginBottom: 10,
            display: 'flex',
            alignItems: 'flex-end'
        }
    }
})